!(function (win) {
  var e = win.document,
    t = e.documentElement,
    d = 750 / 100,
    o = 'orientationchange' in win ? 'orientationchange' : 'resize',
    a = function () {
      var n = t.clientWidth || 375
      n > 750 && (n = 750)
      t.style.fontSize = n / d + 'px' // 1rem = n / d + 'px'
    }
  e.addEventListener &&
    (win.addEventListener(o, a, !1),
    e.addEventListener('DOMContentLoaded', a, !1))
})(window)
